export const planResourceType = 'application/vnd.iris.ai-platform.agent-plan+json';
export var PlanId;
(function (PlanId) {
    PlanId["TRIAL"] = "trial";
    PlanId["PAID"] = "paid";
})(PlanId || (PlanId = {}));
export var PlanStatus;
(function (PlanStatus) {
    PlanStatus["NONE"] = "none";
    PlanStatus["ACTIVE"] = "active";
    PlanStatus["AVAILABLE_TO_UPGRADE"] = "availableToUpgrade";
    PlanStatus["AVAILABLE_TO_TRIAL"] = "availableToTrial";
    PlanStatus["CANCELED"] = "canceled";
})(PlanStatus || (PlanStatus = {}));
export var PlanReason;
(function (PlanReason) {
    PlanReason["BLOCKED"] = "blocked";
    PlanReason["NOT_FOUND"] = "notFound";
    PlanReason["NOT_CONFIGURED"] = "notConfigured";
    PlanReason["CANCELED"] = "canceled";
    PlanReason["PAID"] = "paid";
    PlanReason["TRIAL"] = "trial";
})(PlanReason || (PlanReason = {}));
